import * as d3 from 'd3';

export function startNodeGraphEffect({ canvasEl }) {
  if (!canvasEl) return { setHighlight: () => {}, cleanup: () => {} };

  const ctx = canvasEl.getContext('2d');
  if (!ctx) return { setHighlight: () => {}, cleanup: () => {} };

  const getBounds = () => {
    const parent = canvasEl.parentElement;
    const w = parent && parent.offsetWidth ? parent.offsetWidth : window.innerWidth;
    const h = parent && parent.offsetHeight ? parent.offsetHeight : window.innerHeight;
    return { w: Math.max(1, w), h: Math.max(1, h) };
  };

  let highlightNeedle = '';

  const nodes = [
    { id: 'housing_constraint' },
    { id: 'burnout_risk' },
    { id: 'authenticity_premium' },
    { id: 'shadow_economy' },
    { id: 'platform_power' },
    { id: 'skill_debt' },
    { id: 'climate_risk' },
    { id: 'gentrification' },
    { id: 'data_poisoning' },
    { id: 'ip_fragmentation' }
  ].map((n) => {
    const { w, h } = getBounds();
    return { ...n, x: Math.random() * w, y: Math.random() * h };
  });

  const links = [
    { source: 'housing_constraint', target: 'burnout_risk' },
    { source: 'authenticity_premium', target: 'shadow_economy' },
    { source: 'platform_power', target: 'burnout_risk' },
    { source: 'skill_debt', target: 'shadow_economy' },
    { source: 'climate_risk', target: 'gentrification' },
    { source: 'data_poisoning', target: 'ip_fragmentation' },
    { source: 'shadow_economy', target: 'platform_power' }
  ];

  const resize = () => {
    const { w, h } = getBounds();
    canvasEl.width = w;
    canvasEl.height = h;
    sim.force('center', d3.forceCenter(w / 2, h / 2));
    sim.alpha(0.6).restart();
  };

  const draw = () => {
    ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);

    ctx.strokeStyle = 'rgba(255, 255, 0, 0.2)';
    ctx.lineWidth = 1;
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      const s = link.source;
      const t = link.target;
      if (!s || !t || typeof s.x !== 'number' || typeof t.x !== 'number') continue;
      ctx.beginPath();
      ctx.moveTo(s.x, s.y);
      ctx.lineTo(t.x, t.y);
      ctx.stroke();
    }

    ctx.fillStyle = 'rgba(255, 255, 0, 0.3)';
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      if (typeof node.x !== 'number' || typeof node.y !== 'number') continue;
      ctx.beginPath();
      ctx.arc(node.x, node.y, 5, 0, 2 * Math.PI);
      ctx.fill();
    }

    if (highlightNeedle) {
      const needle = String(highlightNeedle).toLowerCase().replace(/\s+/g, '_');
      const highlightNode = nodes.find((n) => String(n.id).includes(needle));
      if (highlightNode && typeof highlightNode.x === 'number' && typeof highlightNode.y === 'number') {
        ctx.fillStyle = 'rgba(255, 255, 0, 0.8)';
        ctx.beginPath();
        ctx.arc(highlightNode.x, highlightNode.y, 15, 0, 2 * Math.PI);
        ctx.fill();
      }
    }
  };

  const sim = d3
    .forceSimulation(nodes)
    .force('link', d3.forceLink(links).id((d) => d.id).distance(100))
    .force('charge', d3.forceManyBody().strength(-50))
    .force('center', d3.forceCenter(getBounds().w / 2, getBounds().h / 2))
    .force('collision', d3.forceCollide().radius(30));

  sim.on('tick', draw);

  resize();
  window.addEventListener('resize', resize);

  const setHighlight = (nodeName) => {
    highlightNeedle = nodeName ? String(nodeName) : '';
  };

  const cleanup = () => {
    window.removeEventListener('resize', resize);
    sim.stop();
    ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
  };

  return { setHighlight, cleanup };
}
